// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ny-6";
export var imgContainer = "_ny-3";
export var menuIcon = "_ny-5";
export var pillWrapper = "_ny-2";
export var pillsContainer = "_ny-1";
export var subscriptionCard = "_ny-0";
export var subscriptionLogo = "_ny-4";